import React from 'react'
import classNames from 'classnames'

import LanguageSelector from './components/LanguageSelector'
import { navbarStyles } from './utils/navbarStyles'
import styles from './PublicPageNavbar.module.css'

export const PublicPageNavbar: React.FC = () => {
  return (
    <header className={styles.wrapper}>
      <nav className={navbarStyles.nav}>
        <div
          className={classNames(
            navbarStyles.navItemsLayout,
            'justify-end h-16 px-4'
          )}
        >
          <div className="hidden desktop:block">
            <LanguageSelector />
          </div>
          <div className="desktop:hidden">
            <LanguageSelector mobile className="max-w-xs" />
          </div>
        </div>
      </nav>
    </header>
  )
}
